export default __webpack_public_path__ + "static/media/F_wdt_c_cap_1.01c95324.mp3";